import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-picture",
  "use": "icon-picture-usage",
  "viewBox": "0 0 36 27",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 27\" id=\"icon-picture\">\n  <path id=\"icon-picture_iconmonstr-picture-1\" d=\"M7.5,11.25A2.25,2.25,0,1,1,9.75,13.5,2.251,2.251,0,0,1,7.5,11.25ZM21,12l-3.778,6L13.5,15.06,7.5,24h21ZM33,6V27H3V6Zm3-3H0V30H36Z\" transform=\"translate(0 -3)\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol